import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Paper,
  IconButton,
} from "@mui/material";

const Filters = ({
  filters,
  setFilters,
  availableCollaborators,
  availableProducts,
  availableActions,
  locked = false,
}) => {
  const [collabSearch, setCollabSearch] = useState("");

  const toggleItem = (list, item) => {
    return list.includes(item)
      ? list.filter((i) => i !== item)
      : [...list, item];
  };

  const filteredCollabs = availableCollaborators.filter((c) =>
    c.toLowerCase().includes(collabSearch.toLowerCase()),
  );

  const setPreset = (preset) => {
    const now = new Date();
    const today = now.toISOString().split("T")[0];

    switch (preset) {
      case "today":
        setFilters({ ...filters, startDate: today, endDate: today });
        break;
      case "thisMonth": {
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
          .toISOString()
          .split("T")[0];
        setFilters({ ...filters, startDate: firstDay, endDate: today });
        break;
      }
      case "thisYear": {
        const firstDayOfYear = new Date(now.getFullYear(), 0, 1)
          .toISOString()
          .split("T")[0];
        setFilters({ ...filters, startDate: firstDayOfYear, endDate: today });
        break;
      }
      case "all":
        setFilters({ ...filters, startDate: "", endDate: "" });
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        pointerEvents: locked ? "none" : "auto",
        opacity: locked ? 0.8 : 1,
      }}
    >
      {/* Filtro Temporale Avanzato */}
      <Paper
        sx={{
          p: 2,
          borderRadius: 3,
          border: 1,
          borderColor: "rgba(51, 65, 85, 0.5)",
        }}
        elevation={0}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "0.625rem",
              fontWeight: 900,
              color: "text.secondary",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
            }}
          >
            Periodo Analisi
          </Typography>
          {!locked && (
            <Button
              onClick={() => setPreset("all")}
              sx={{
                minWidth: "auto",
                p: 0,
                fontSize: "0.5625rem",
                fontWeight: "bold",
                color: "text.secondary",
                "&:hover": { color: "primary.light" },
                textTransform: "uppercase",
                letterSpacing: "-0.02em",
              }}
            >
              Reset
            </Button>
          )}
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 1,
            mb: 2,
          }}
        >
          <Button
            disabled={locked}
            onClick={() => setPreset("thisMonth")}
            variant="outlined"
            sx={{
              py: 1,
              px: 0.5,
              borderColor: "rgba(51, 65, 85, 1)",
              borderRadius: 2,
              fontSize: "0.5625rem",
              fontWeight: 900,
              color: "grey.400",
              "&:hover": { borderColor: "primary.main", color: "white" },
              textTransform: "uppercase",
              letterSpacing: "-0.02em",
            }}
          >
            Mese
          </Button>
          <Button
            disabled={locked}
            onClick={() => setPreset("thisYear")}
            variant="outlined"
            sx={{
              py: 1,
              px: 0.5,
              borderColor: "rgba(51, 65, 85, 1)",
              borderRadius: 2,
              fontSize: "0.5625rem",
              fontWeight: 900,
              color: "grey.400",
              "&:hover": { borderColor: "primary.main", color: "white" },
              textTransform: "uppercase",
              letterSpacing: "-0.02em",
            }}
          >
            Anno
          </Button>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              sx={{
                fontSize: "0.5rem",
                color: "grey.600",
                fontWeight: 900,
                textTransform: "uppercase",
                zIndex: 1,
              }}
            >
              Dal
            </Typography>
            <Box sx={{ position: "relative", flex: 1 }}>
              <TextField
                type="date"
                disabled={locked}
                value={filters.endDate}
                onChange={(e) =>
                  setFilters({ ...filters, endDate: e.target.value })
                }
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "secondary.main",
                    borderRadius: 2,
                    "& fieldset": { borderColor: "rgba(51, 65, 85, 1)" },
                    "&:hover fieldset": { borderColor: "primary.main" },
                    "&.Mui-focused fieldset": { borderColor: "primary.main" },
                  },
                  "& .MuiInputBase-input": {
                    pl: 4,
                    pr: 1,
                    py: 1,
                    fontSize: "0.6875rem",
                    color: "white",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              sx={{
                fontSize: "0.5rem",
                color: "grey.600",
                fontWeight: 900,
                textTransform: "uppercase",
                zIndex: 1,
                mr: 2,
              }}
            >
              Al
            </Typography>
            <TextField
              type="date"
              disabled={locked}
              value={filters.endDate}
              onChange={(e) =>
                setFilters({ ...filters, endDate: e.target.value })
              }
              variant="outlined"
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "secondary.main",
                  borderRadius: 2,
                  "& fieldset": { borderColor: "rgba(51, 65, 85, 1)" },
                  "&:hover fieldset": { borderColor: "primary.main" },
                  "&.Mui-focused fieldset": { borderColor: "primary.main" },
                },
                "& .MuiInputBase-input": {
                  pl: 4,
                  pr: 1,
                  py: 1,
                  fontSize: "0.6875rem",
                  color: "white",
                },
              }}
            />
          </Box>
        </Box>
      </Paper>

      <Box sx={{ display: locked ? "none" : "block" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1.5,
          }}
        >
          <Typography
            sx={{
              fontSize: "0.625rem",
              fontWeight: 900,
              color: "text.secondary",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              flexGrow: 1,
            }}
          >
            Collaboratori
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              onClick={() =>
                setFilters({
                  ...filters,
                  collaborators: availableCollaborators,
                })
              }
              sx={{
                minWidth: "auto",
                p: 0,
                fontSize: "0.5625rem",
                fontWeight: "bold",
                color: "primary.main",
                "&:hover": { color: "primary.light" },
                textTransform: "uppercase",
                letterSpacing: "-0.02em",
              }}
            >
              Tutti
            </Button>
            <Button
              onClick={() => setFilters({ ...filters, collaborators: [] })}
              sx={{
                minWidth: "auto",
                p: 0,
                fontSize: "0.5625rem",
                fontWeight: "bold",
                color: "grey.600",
                "&:hover": { color: "grey.500" },
                textTransform: "uppercase",
                letterSpacing: "-0.02em",
              }}
            >
              Clear
            </Button>
          </Box>
        </Box>
        <Box sx={{ mb: 1 }}>
          <TextField
            placeholder="Search..."
            value={collabSearch}
            onChange={(e) => setCollabSearch(e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                "& fieldset": { borderColor: "rgba(51, 65, 85, 1)" },
                "&:hover fieldset": { borderColor: "primary.main" },
                "&.Mui-focused fieldset": { borderColor: "primary.main" },
              },
              "& .MuiInputBase-input": {
                px: 1.5,
                py: 1,
                fontSize: "0.6875rem",
                color: "white",
                "&::placeholder": { color: "rgba(51, 65, 85, 1)" },
              },
            }}
          />
        </Box>
        <Box
          sx={{
            maxHeight: 160,
            overflowY: "scroll",
            scrollbarWidth: "none",
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            p: 1,
            borderRadius: 2,
            border: 1,
            borderColor: "rgba(51, 65, 85, 1)",
          }}
        >
          {filteredCollabs.map((c) => (
            <FormControlLabel
              key={c}
              control={
                <Checkbox
                  checked={filters.collaborators.includes(c)}
                  onChange={() =>
                    setFilters({
                      ...filters,
                      collaborators: toggleItem(filters.collaborators, c),
                    })
                  }
                  size="small"
                  sx={{
                    color: "rgba(71, 85, 105, 1)",
                    "&.Mui-checked": { color: "primary.main" },
                    p: 0.5,
                  }}
                />
              }
              label={
                <Typography
                  sx={{
                    fontSize: "0.6875rem",
                    textTransform: "uppercase",
                    letterSpacing: "-0.02em",
                    fontWeight: "bold",
                    color: filters.collaborators.includes(c)
                      ? "primary.light"
                      : "grey.500",
                    "&:hover": { color: "grey.300" },
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {c}
                </Typography>
              }
              sx={{
                m: 0,
                p: 0.5,
                borderRadius: 1,
                "&:hover": { bgcolor: "rgba(51, 65, 85, 0.5)" },
                transition: "background-color 0.3s",
              }}
            />
          ))}
        </Box>
      </Box>

      {locked && (
        <Paper
          sx={{
            bgcolor: "rgba(249, 115, 22, 0.1)",
            p: 2,
            borderRadius: 3,
            border: 1,
            borderColor: "rgba(249, 115, 22, 0.2)",
          }}
          elevation={0}
        >
          <Typography
            sx={{
              fontSize: "0.625rem",
              fontWeight: 900,
              color: "primary.light",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              mb: 0.5,
              display: "block",
            }}
          >
            Account Limitato
          </Typography>
          <Typography
            sx={{
              fontSize: "0.6875rem",
              fontWeight: "bold",
              color: "grey.300",
              textTransform: "uppercase",
              letterSpacing: "-0.02em",
            }}
          >
            Stai visualizzando esclusivamente i dati di: <br />
            <Box component="span" sx={{ color: "white" }}>
              {filters.collaborators[0]}
            </Box>
          </Typography>
        </Paper>
      )}

      <Box
        sx={{
          pt: 1,
          borderTop: 1,
          borderColor: "secondary.light",
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              disabled={locked}
              checked={filters.excludeStar}
              onChange={(e) =>
                setFilters({ ...filters, excludeStar: e.target.checked })
              }
              size="small"
              sx={{
                color: "rgba(71, 85, 105, 1)",
                "&.Mui-checked": { color: "primary.main" },
                p: 0.5,
              }}
            />
          }
          label={
            <Typography
              sx={{
                fontSize: "0.625rem",
                fontWeight: 900,
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                color: "grey.500",
                "&:hover": { color: "grey.300" },
                transition: "color 0.3s",
              }}
            >
              Escludi Polizze con *
            </Typography>
          }
          sx={{ m: 0 }}
        />
      </Box>
    </Box>
  );
};

export default Filters;
